import * as actionType from "../types/ActionTypes";
import axios from "../../shared/axios";
import Swal from "sweetalert2";
import { baseUrl } from "../../shared/baseURL";

export const weekDaysSetData = (weekDays) => {
  return {
    type: actionType.WEEK_DAYS_SET_DATA,
    weekDays: weekDays,
  };
};

export const weekDaysFailData = (error) => {
  return {
    type: actionType.WEEK_DAYS_FAIL_DATA,
    error: error,
  };
};

export const weekDaysLoading = () => {
  return {
    type: actionType.WEEK_DAYS_LOADING,
  };
};

export const weekDaysGetData = () => {
  return (dispatch) => {
    dispatch(weekDaysLoading());
    axios
      .get(baseUrl + "/week-days", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(weekDaysSetData(res.data));
      })
      .catch((error) => dispatch(weekDaysFailData(error)));
  };
};

export const deleteWeekDaysFail = (error) => {
  return {
    type: actionType.DELETE_WEEK_DAYS_FAIL,
    error: error,
  };
};

export const deleteWeekDays = (id, data) => {
  return (dispatch) => {
    if (id) {
      axios
        .delete(baseUrl + `/week-days/${data.id}`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data?.token,
          },
        })
        .then(() => {
          Swal.fire("Deleted!", "Your file has been deleted.", "success").then(
            () => {
              dispatch(weekDaysGetData(data));
            }
          );
        })
        .catch((error) => dispatch(deleteWeekDaysFail()));
    }
  };
};

export const postWeekDaysDataStart = () => {
  return {
    type: actionType.POST_WEEK_DAYS_DATA_START,
  };
};

export const postWeekDaysDataFail = (error) => {
  return {
    type: actionType.POST_WEEK_DAYS_DATA_FAIL,
    error: error,
  };
};

export const postWeekDaysDataSuccess = (success) => {
  return {
    type: actionType.POST_WEEK_DAYS_DATA_SUCCESS,
    success: success,
  };
};

export const weekDaysPostLoading = () => {
  return {
    type: actionType.WEEK_DAYS_POST_LOADING,
  };
};

export const postWeekDaysData = (data, weekDays, toggle, setSubmitting) => {
  return (dispatch) => {
    dispatch(postWeekDaysDataStart());
    dispatch(weekDaysPostLoading());
    axios
      .post(baseUrl + "/week-days", weekDays, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(postWeekDaysDataSuccess(res.data));
        dispatch(weekDaysGetData(data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Created",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (toggle) {
            toggle();
          }
          if (setSubmitting) {
            setSubmitting(false);
          }
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(postWeekDaysDataFail(error));
      });
  };
};

export const updateWeekDaysDataStart = () => {
  return {
    type: actionType.UPDATE_WEEK_DAYS_DATA_START,
  };
};

export const weekDaysUpdateLoading = () => {
  return {
    type: actionType.WEEK_DAYS_UPDATE_LOADING,
  };
};

export const updateWeekDaysDataFail = (error) => {
  return {
    type: actionType.UPDATE_WEEK_DAYS_DATA_FAIL,
    error: error,
  };
};

export const updateWeekDaysDataSuccess = (success) => {
  return {
    type: actionType.UPDATE_WEEK_DAYS_DATA_SUCCESS,
    success: success,
  };
};

export const updateWeekDaysData = (data, weekDays, toggle, setSubmitting) => {
  return (dispatch) => {
    dispatch(updateWeekDaysDataStart());
    dispatch(weekDaysUpdateLoading());

    axios
      .put(baseUrl + `/week-days/${data.id}`, weekDays, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(updateWeekDaysDataSuccess(res.data));
        dispatch(weekDaysGetData(data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Updated !",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (toggle) {
            toggle();
          }
          if (setSubmitting) {
            setSubmitting(false);
          }
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(updateWeekDaysDataFail(error));
      });
  };
};
